export default __webpack_public_path__ + "static/images/2762519ebb25210a87b361cf24c872ad.png";